import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import Header from "../../Header/Header";

import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import privateRequest, { Image_URL } from "../../commonApi/CommonApi";
import Swal from "sweetalert2";
import ReactQuill from "react-quill";

function EditService() {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [itemm, setItemm] = useState(location.state);
  const [isLoading, setIsLoading] = useState(!location.state);
  const navigate = useNavigate();

  console.log('EditService component mounted, pathname:', location.pathname, 'search:', location.search);

  // Fetch service data from API if no location.state (e.g., opened in new tab)
  useEffect(() => {
    const fetchServiceData = async () => {
      if (!itemm) {
        const serviceId = searchParams.get('serviceId');
        console.log('EditService - no location.state, attempting to fetch service with ID:', serviceId);

        if (serviceId) {
          try {
            setIsLoading(true);
            // Fetch all services and find the one we need
            const response = await privateRequest.get(`Service/GetServices`);
            const services = response?.data?.data || [];
            const service = services.find(s => s._id === serviceId);

            if (service) {
              console.log('EditService - found service from API:', service);
              setItemm(service);
            } else {
              console.error('EditService - service not found with ID:', serviceId);
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Service not found. Please try again.',
              });
            }
          } catch (error) {
            console.error('Error fetching service data:', error);
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Failed to load service data. Please try again.',
            });
          } finally {
            setIsLoading(false);
          }
        } else {
          // Try sessionStorage as fallback
          try {
            const storedData = sessionStorage.getItem('serviceEditData');
            if (storedData) {
              const parsedItem = JSON.parse(storedData);
              console.log('EditService - loaded from sessionStorage:', parsedItem);
              setItemm(parsedItem);
              sessionStorage.removeItem('serviceEditData');
            }
          } catch (error) {
            console.error('Error parsing service data from sessionStorage:', error);
          }
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    fetchServiceData();
  }, [searchParams]);

  const [imagePreview, setImagePreview] = useState(null);
  const [editorData, setEditorData] = useState("");
  const [editorData1, setEditorData1] = useState("");
  const [combineData, setCombineData] = useState([]);
  const [SelectServiceType, setSelectedServiceType] = useState();

  const [Name, setName] = useState(itemm?.ServiceName);
  // Debug: Log the service data structure
  console.log("=== SERVICE DATA DEBUG ===");
  console.log("Full itemm object:", itemm);
  console.log("itemm.ServiceStatus:", itemm?.ServiceStatus);
  console.log("itemm.ServiceStatus type:", typeof itemm?.ServiceStatus);
  console.log("itemm.ServiceVarients:", itemm?.ServiceVarients);



  const [Time, setTime] = useState(itemm?.ServiceTime);

  // Update form fields when itemm is loaded from sessionStorage
  useEffect(() => {
    if (itemm) {
      console.log('EditService - itemm loaded, updating form fields');
      setName(itemm.ServiceName || '');
      setTime(itemm.ServiceTime || '');
    }
  }, [itemm]);
  const [selectedParentCategory, setSelectedParentCategory] = useState({});
  const [serviceVariants, setServiceVariants] = useState([]);

  const [childCategoryOptions, setChildCategoryOptions] = useState([]);
  const [selectedChildCategories, setSelectedChildCategories] = useState();
  const [ServiceGroupOptions, setServiceGroupOptions] = useState([]);
  const [SelectedServiceGroup, setSelectedServiceGroup] = useState([]);
  const [ServiceTypeOptions, setServiceTypeOptions] = useState([]);
  const [isDiscription, setisDiscription] = useState(false);
  const [targetArray, setTargetArray] = useState([]);
  const ServiceStatus = hasAnyActiveVariant(serviceVariants) ? 1 : 0;

  console.log("ServiceVarinats", serviceVariants);
  console.log("SelectServiceType", SelectServiceType);



  function hasAnyActiveVariant(variants) {
    return variants?.some(
      (v) =>
        v?.VariantDescription?.[0]?.Status === "1" ||
        v?.VariantDescription?.[0]?.Status === 1
    );
  }

  const areAllVariantsInactive = (variants) => {
    return (
      variants?.length > 0 &&
      variants.every(
        (v) =>
          v?.VariantDescription?.[0]?.Status === "0" ||
          v?.VariantDescription?.[0]?.Status === 0
      )
    );
  };

  const originalVariantStatusMap = new Map(
    itemm?.ServiceVarients?.map(v => [
      v._id,
      v?.VarientDiscription?.[0]?.ServiceStatus === true ? "1" : "0"
    ])
  );

  const rollbackVariantStatus = (variantIds) => {
    setServiceVariants(prev =>
      prev.map(variant => {
        if (!variantIds.includes(variant._id)) return variant;

        return {
          ...variant,
          VariantDescription: variant.VariantDescription.map(desc => ({
            ...desc,
            Status: originalVariantStatusMap.get(variant._id) || "1",
          })),
        };
      })
    );
  };


  useEffect(() => {
    if (SelectServiceType !== undefined) {
      const updatedVariants = SelectServiceType.map((serviceType) => {
        const existingVariant = serviceVariants.find(
          (variant) => variant.ServiceType === serviceType.selectedIds
        );
        console.log("existingVariant", existingVariant);
        if (existingVariant) {
          return existingVariant;
        } else {
          return {
            ServiceType: serviceType._id,
            VariantDescription: [
              {
                regularPrice: "",
                salePrice: "",
                serviceDiscount: "",
                ServiceGroup: "",
                ServiceTiming: "",
                Imagee: "",
                ShortDiscription: "",
                Status: "",
                Discription: "",
                ShowInChildCategory: "",
              },
            ],
          };
        }
      });

      setServiceVariants(updatedVariants);
    }
  }, [SelectServiceType]);

  // useEffect(() => {
  //   if (SelectServiceType !== undefined) {
  //     const newVariant = {
  //       VariantDescription: [
  //         {
  //           regularPrice: "",
  //           salePrice: "",
  //           serviceDiscount: "",
  //           ServiceGroup: "",
  //           ServiceTiming: "",
  //           Imagee: "",
  //           ShortDiscription: "",
  //           Status: "",
  //           Discription: "",
  //           ShowInChildCategory: "",
  //           IsServiceDiscription: false,
  //         },
  //       ],
  //     };

  //     if (SelectServiceType.length === 0) {
  //       setServiceVariants([newVariant]);
  //     } else {
  //       setServiceVariants((prevVariants) => [...prevVariants, newVariant]);
  //     }
  //   }
  // }, [SelectServiceType]);

  const handleServiceStatusChange = (value) => {
    const status = Number(value);

    // Service → Inactive → force all variants inactive
    if (status === 0) {
      setServiceVariants((prev) =>
        prev.map((variant) => ({
          ...variant,
          VariantDescription: variant.VariantDescription.map((desc) => ({
            ...desc,
            Status: "0",
          })),
        }))
      );
    }

    // ✅ Service → Active → activate FIRST variant automatically
    if (status === 1) {
      setServiceVariants((prev) => {
        if (hasAnyActiveVariant(prev)) return prev;

        return prev.map((variant, index) => ({
          ...variant,
          VariantDescription: variant.VariantDescription.map((desc) => ({
            ...desc,
            Status: index === 0 ? "1" : desc.Status,
          })),
        }));
      });
    }
  };







  const getAllDocumentData = async () => {
    try {
      const response = await privateRequest.get(`Service/CombineApis`);
      setCombineData(response?.data?.data);
    } catch (error) {
      console.error("Error fetching parent category groups:", error);
    }
  };

  const getPackagesUsingServiceVariant = async (serviceVariantId) => {
    try {
      const response = await privateRequest.get(`Package/GetPackagesByServiceVariant/${serviceVariantId}`);
      return response?.data?.data || [];
    } catch (error) {
      console.error("Error fetching packages using service variant:", error);
      return [];
    }
  };

  const findPackagesUsingServiceVariant = (serviceVariantId) => {
    if (!combineData?.Package || !serviceVariantId) {
      console.log("No combineData.Package or serviceVariantId:", {
        hasPackage: !!combineData?.Package,
        serviceVariantId
      });
      return [];
    }

    console.log("Searching for variant ID:", serviceVariantId);
    console.log("Available packages structure:", combineData.Package.map(pkg => ({
      id: pkg._id,
      title: pkg.packageTitle,
      serviceId: pkg.serviceId,
      services: pkg.services,
      ServiceVarients: pkg.ServiceVarients
    })));

    const matchingPackages = combineData.Package.filter(pkg => {
      console.log("Checking package:", pkg.packageTitle || pkg.name || pkg._id);

      // Check different possible structures for service references in packages

      // Case 1: serviceId array with variant property
      if (pkg.serviceId && Array.isArray(pkg.serviceId)) {
        console.log("Package has serviceId array:", pkg.serviceId);
        const hasMatch = pkg.serviceId.some(service => {
          console.log("🔍 Detailed service object:", JSON.stringify(service, null, 2));
          console.log("Service keys:", Object.keys(service));
          console.log("Checking against variant:", serviceVariantId);

          // Check all possible property names
          const match = service.variant === serviceVariantId ||
            service.service === serviceVariantId ||
            service._id === serviceVariantId ||
            service.id === serviceVariantId ||
            service.serviceVariant === serviceVariantId ||
            service.variantId === serviceVariantId;

          console.log(`Comparing:
             service.variant (${service.variant}) === ${serviceVariantId} ? ${service.variant === serviceVariantId}
             service.service (${service.service}) === ${serviceVariantId} ? ${service.service === serviceVariantId}
             service._id (${service._id}) === ${serviceVariantId} ? ${service._id === serviceVariantId}`);

          if (match) {
            console.log("✅ MATCH FOUND in serviceId array!");
          }

          return match;
        });
        if (hasMatch) {
          console.log("Found match in serviceId array");
          return true;
        }
      }

      // Case 2: serviceId array with direct variant IDs
      if (pkg.serviceId && Array.isArray(pkg.serviceId)) {
        const hasMatch = pkg.serviceId.includes(serviceVariantId);
        if (hasMatch) {
          console.log("Found match in serviceId array (direct)");
          return true;
        }
      }

      // Case 3: Check if package has service variants directly
      if (pkg.ServiceVarients && Array.isArray(pkg.ServiceVarients)) {
        console.log("Package has ServiceVarients array:", pkg.ServiceVarients);
        const hasMatch = pkg.ServiceVarients.some(variant => {
          console.log("Checking variant:", variant._id, "against:", serviceVariantId);
          return variant._id === serviceVariantId;
        });
        if (hasMatch) {
          console.log("Found match in ServiceVarients array");
          return true;
        }
      }

      // Case 4: Check if package has services array
      if (pkg.services && Array.isArray(pkg.services)) {
        console.log("Package has services array:", pkg.services);
        const hasMatch = pkg.services.some(service => {
          console.log("Checking service:", service, "against variant:", serviceVariantId);
          return service.variant === serviceVariantId ||
            service.service === serviceVariantId ||
            service._id === serviceVariantId;
        });
        if (hasMatch) {
          console.log("Found match in services array");
          return true;
        }
      }

      return false;
    });

    console.log("Matching packages found:", matchingPackages);
    return matchingPackages;
  };

  const findPackagesUsingService = (serviceId) => {
    if (!combineData?.Package || !serviceId) {
      console.log("No combineData.Package or serviceId:", {
        hasPackage: !!combineData?.Package,
        serviceId
      });
      return [];
    }

    console.log("Searching for service ID:", serviceId);

    const matchingPackages = combineData.Package.filter(pkg => {
      console.log("Checking package for service:", pkg.packageTitle || pkg.name || pkg._id);

      // Check if package uses this service
      if (pkg.serviceId && Array.isArray(pkg.serviceId)) {
        const hasMatch = pkg.serviceId.some(service => {
          return service.service === serviceId || service === serviceId;
        });
        if (hasMatch) {
          console.log("Found match in serviceId array for service");
          return true;
        }
      }

      // Check if package has services array
      if (pkg.services && Array.isArray(pkg.services)) {
        const hasMatch = pkg.services.some(service => {
          return service.service === serviceId || service._id === serviceId;
        });
        if (hasMatch) {
          console.log("Found match in services array for service");
          return true;
        }
      }

      return false;
    });

    console.log("Matching packages found for service:", matchingPackages);
    return matchingPackages;
  };

  const filteredData = serviceVariants.filter((item) => item.ServiceType);

  // Function to proceed with service update
  const proceedWithServiceUpdate = async (allowedUpdates = { allowStatusUpdate: true, allowFormDataUpdate: true }) => {
    try {
      const formData = new FormData();
      formData.append("ServiceName", Name);
      formData.append("PCatId", selectedParentCategory?.value);
      formData.append(
        "ChildCatIDs",
        selectedChildCategories[0]?.value || selectedChildCategories?.value
      );

      // Only update service status if allowed
      if (allowedUpdates.allowStatusUpdate) {
        formData.append("ServiceStatus", ServiceStatus === 1 ? true : false);
      } else {
        // Keep original service status
        formData.append("ServiceStatus", itemm?.ServiceStatus == true ? true : false);
      }
      filteredData.forEach((variant, index) => {
        formData.append(
          `ServiceVarients[${index}][ServiceType]`,
          variant.ServiceType
        );
        // Only update form data if allowed
        if (allowedUpdates.allowFormDataUpdate) {
          formData.append(
            `ServiceVarients[${index}][VarientDiscription][regularPrice]`,
            variant.VariantDescription[0].regularPrice || ""
          );
        } else {
          // Keep original regular price
          const originalPrice = itemm?.ServiceVarients?.[index]?.VarientDiscription?.[0]?.regularPrice;
          formData.append(
            `ServiceVarients[${index}][VarientDiscription][regularPrice]`,
            originalPrice || ""
          );
        }
        // Only update variant status if allowed
        if (allowedUpdates.allowStatusUpdate) {
          formData.append(
            `ServiceVarients[${index}][VarientDiscription][ServiceStatus]`,
            variant.VariantDescription[0].Status === "1" || variant.VariantDescription[0].Status === 1 ? true : false
          );
        } else {
          // Keep original variant status
          const originalStatus = itemm?.ServiceVarients?.[index]?.VarientDiscription?.[0]?.ServiceStatus;
          formData.append(
            `ServiceVarients[${index}][VarientDiscription][ServiceStatus]`,
            originalStatus == true ? true : false
          );
        }
        // Update other form fields based on allowFormDataUpdate
        const updateField = (fieldName, currentValue, originalValue) => {
          if (allowedUpdates.allowFormDataUpdate) {
            formData.append(
              `ServiceVarients[${index}][VarientDiscription][${fieldName}]`,
              currentValue || ""
            );
          } else {
            formData.append(
              `ServiceVarients[${index}][VarientDiscription][${fieldName}]`,
              originalValue || ""
            );
          }
        };

        const originalVariant = itemm?.ServiceVarients?.[index]?.VarientDiscription?.[0];

        updateField("ServiceTime", variant.VariantDescription[0].ServiceTiming, originalVariant?.ServiceTime);
        updateField("salePrice", variant.VariantDescription[0].salePrice, originalVariant?.salePrice);
        updateField("ProductCost", variant.VariantDescription[0].ProductCost, originalVariant?.ProductCost);
        updateField("serviceDiscount", variant.VariantDescription[0].serviceDiscount, originalVariant?.serviceDiscount);
        updateField("ShortDiscription", variant.VariantDescription[0].ShortDiscription, originalVariant?.ShortDiscription);
        updateField("ServiceDiscription", variant.VariantDescription[0].Discription, originalVariant?.ServiceDiscription);
        updateField("ServiceImage", variant.VariantDescription[0].Imagee, originalVariant?.ServiceImage);

        // Handle boolean field
        if (allowedUpdates.allowFormDataUpdate) {
          formData.append(
            `ServiceVarients[${index}][VarientDiscription][IsServiceDiscription]`,
            variant.VariantDescription[0].IsServiceDiscription || false
          );
        } else {
          formData.append(
            `ServiceVarients[${index}][VarientDiscription][IsServiceDiscription]`,
            originalVariant?.IsServiceDiscription || false
          );
        }

        // Handle ServiceGroups array
        if (allowedUpdates.allowFormDataUpdate) {
          if (variant.VariantDescription[0].ServiceGroup && Array.isArray(variant.VariantDescription[0].ServiceGroup)) {
            variant.VariantDescription[0].ServiceGroup.forEach((groupId) => {
              formData.append(
                `ServiceVarients[${index}][VarientDiscription][ServiceGroups]`,
                groupId
              );
            });
          }
        } else {
          // Keep original ServiceGroups
          if (originalVariant?.ServiceGroups && Array.isArray(originalVariant.ServiceGroups)) {
            originalVariant.ServiceGroups.forEach((group) => {
              formData.append(
                `ServiceVarients[${index}][VarientDiscription][ServiceGroups]`,
                group._id || group
              );
            });
          }
        }

        // Handle ShowInChildCategory array
        if (allowedUpdates.allowFormDataUpdate) {
          if (variant.VariantDescription[0].ShowInChildCategory && Array.isArray(variant.VariantDescription[0].ShowInChildCategory)) {
            variant.VariantDescription[0].ShowInChildCategory.forEach((categoryId) => {
              formData.append(
                `ServiceVarients[${index}][VarientDiscription][ShowInChildCategory]`,
                categoryId
              );
            });
          }
        } else {
          // Keep original ShowInChildCategory
          if (originalVariant?.ShowInChildCategory && Array.isArray(originalVariant.ShowInChildCategory)) {
            originalVariant.ShowInChildCategory.forEach((category) => {
              formData.append(
                `ServiceVarients[${index}][VarientDiscription][ShowInChildCategory]`,
                category._id || category
              );
            });
          }
        }
      });

      // Debug: Log the data being sent (can be removed later)
      console.log("Updating service:", Name, "with ID:", itemm?._id);
      console.log("Allowed updates:", allowedUpdates);

      const response = await privateRequest.put(
        `Service/UpdateServices/${itemm?._id}`,
        formData
      );
      console.log("response", response);

      // Show success message based on what was updated
      let successMessage = "Service updated successfully!";
      if (allowedUpdates.allowStatusUpdate && allowedUpdates.allowFormDataUpdate) {
        successMessage = "Service status and form data updated successfully!";
      } else if (allowedUpdates.allowStatusUpdate) {
        successMessage = "Service status updated successfully!";
      } else if (allowedUpdates.allowFormDataUpdate) {
        successMessage = "Service form data updated successfully!";
      }

      Swal.fire({
        icon: "success",
        title: "Success!",
        text: successMessage,
      });
      navigate("/service");
    } catch (error) {
      console.error("Error creating service:", error);

      // Check if the error is about ServiceVariant being used in packages
      if (error?.response?.data?.message?.includes("ServiceVariant is used in the following packages")) {
        // Try to get package names from the error response or make a separate call
        const packageNames = error?.response?.data?.packages || [];
        let errorMessage = error?.response?.data?.message;

        if (packageNames && packageNames.length > 0) {
          errorMessage += "\n\nPackages using this ServiceVariant:\n" + packageNames.join("\n");
        } else {
          // Try to fetch package names using service variant IDs
          const serviceVariantIds = serviceVariants.map(variant => variant._id).filter(id => id);
          if (serviceVariantIds.length > 0) {
            try {
              // First try API call
              const packages = await getPackagesUsingServiceVariant(serviceVariantIds[0]);
              if (packages && packages.length > 0) {
                const packageNames = packages.map(pkg => pkg.packageTitle || pkg.name || pkg._id);
                errorMessage += "\n\nPackages using this ServiceVariant:\n" + packageNames.join("\n");
              } else {
                // Fallback to local search in combineData
                const localPackages = findPackagesUsingServiceVariant(serviceVariantIds[0]);
                if (localPackages && localPackages.length > 0) {
                  const packageNames = localPackages.map(pkg => pkg.packageTitle || pkg.name || pkg._id);
                  errorMessage += "\n\nPackages using this ServiceVariant:\n" + packageNames.join("\n");
                } else {
                  errorMessage += "\n\nPlease check which packages are using this ServiceVariant before updating.";
                }
              }
            } catch (fetchError) {
              console.error("Error fetching package names:", fetchError);
              // Fallback to local search in combineData
              const localPackages = findPackagesUsingServiceVariant(serviceVariantIds[0]);
              if (localPackages && localPackages.length > 0) {
                const packageNames = localPackages.map(pkg => pkg.packageTitle || pkg.name || pkg._id);
                errorMessage += "\n\nPackages using this ServiceVariant:\n" + packageNames.join("\n");
              } else {
                errorMessage += "\n\nPlease check which packages are using this ServiceVariant before updating.";
              }
            }
          } else {
            errorMessage += "\n\nPlease check which packages are using this ServiceVariant before updating.";
          }
        }

        Swal.fire({
          icon: "error",
          title: "Error!",
          text: errorMessage,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: error?.response?.data?.message || "An error occurred while updating the service.",
        });
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log("=== HANDLE SUBMIT START ===");

    // 1️⃣ Detect variants being turned OFF (Active → Inactive)
    const variantsBeingInactivated = serviceVariants.filter((variant) => {
      const originalStatus = originalVariantStatusMap.get(variant._id);
      const currentStatus = variant?.VariantDescription?.[0]?.Status;
      return originalStatus === "1" && currentStatus === "0";
    });

    // 2️⃣ Nothing risky → save directly
    if (variantsBeingInactivated.length === 0) {
      proceedWithServiceUpdate();
      return;
    }

    // 3️⃣ Collect packages ONLY for these variants
    let packagesBlocking = [];

    for (const variant of variantsBeingInactivated) {
      if (!variant._id) continue;
      const packages = findPackagesUsingServiceVariant(variant._id);
      if (packages.length > 0) packagesBlocking.push(...packages);
    }

    // 4️⃣ Variant not used anywhere → safe
    if (packagesBlocking.length === 0) {
      proceedWithServiceUpdate();
      return;
    }

    // 5️⃣ Remove duplicate packages
    const uniquePackages = packagesBlocking.filter(
      (pkg, index, self) =>
        index === self.findIndex((p) => p._id === pkg._id)
    );

    // 6️⃣ Package status helper
    const getPackageStatus = (pkg) => {
      return pkg.Status === true ||
        pkg.Status === 1 ||
        pkg.status === true ||
        pkg.status === 1
        ? "active"
        : "inactive";
    };

    // 7️⃣ Build compact table rows (SECOND IMAGE)
    const packagesTable = uniquePackages
      .map((pkg) => {
        const isActive = getPackageStatus(pkg) === "active";

        return `
          <tr>
            <td style="padding:10px 14px; font-size:13px;">
              ${pkg.packageTitle || pkg.name || pkg._id}
            </td>
            <td style="text-align:center;">
              <span style="
                padding:4px 10px;
                font-size:11px;
                border-radius:12px;
                color:#fff;
                background:${isActive ? "#28a745" : "#6c757d"};
              ">
                ${isActive ? "Active" : "Inactive"}
              </span>
            </td>
            <td style="text-align:center;">
              <button
                style="
                  font-size:11px;
                  padding:4px 10px;
                  border-radius:4px;
                  border:none;
                  background:#0d6efd;
                  color:#fff;
                  cursor:pointer;
                "
                onclick="editPackage('${pkg._id}')">
                ✏️ Edit
              </button>
            </td>
          </tr>
        `;
      })
      .join("");

    // 8️⃣ Modal HTML (SECOND IMAGE STYLE)
    const tableHTML = `
      <div style="text-align:center; margin-bottom:12px;">
        <div style="
          width:72px;
          height:72px;
          border-radius:50%;
          border:4px solid #f0ad4e;
          display:inline-flex;
          align-items:center;
          justify-content:center;
          font-size:34px;
          color:#f0ad4e;
          font-weight:700;
        ">!</div>
      </div>

      <!-- TITLE -->
      <h3 style="text-align:center; font-weight:600; margin-bottom:14px;">
        Service Used in Packages
      </h3>

      <!-- WARNING BAR -->
      <div style="
        background:#fff3cd;
        border:1px solid #ffeeba;
        color:#856404;
        padding:10px 16px;
        font-size:13px;
        border-radius:6px;
        margin-bottom:14px;
        text-align:center;
      ">
        ⚠️ Service is used in active packages.
        You can update form data only, or inactivate all packages first to change status.
      </div>

      <!-- TABLE CARD -->
      <div style="
        border:1px solid #dee2e6;
        border-radius:6px;
        overflow:hidden;
        background:#fff;
      ">
        <table style="width:100%; border-collapse:collapse;">
          <thead style="background:#343a40; color:#fff;">
            <tr style="height:36px; background:#343a40; color:#fff;">
              <th style="padding:6px 10px; font-size:12px; font-weight:600; text-align:left;">
                📦 Package Details
              </th>

              <th style="padding:6px 10px; font-size:12px; font-weight:600; text-align:center;">
                ℹ️ Status
              </th>

              <th style="padding:6px 10px; font-size:12px; font-weight:600; text-align:center;">
                ✏️ Action
              </th>
            </tr>

          </thead>
          <tbody>
            ${packagesTable}
          </tbody>
        </table>
      </div>

      <!-- FOOTER NOTE -->
      <div style="
        margin-top:10px;
        font-size:12px;
        color:#6c757d;
        text-align:center;
      ">
        ℹ️ Options:
        1) Update form data only
        2) Edit packages to inactivate them
        3) Cancel to abort changes
      </div>
    `;

    // 9️⃣ SweetAlert
    Swal.fire({
      icon: undefined, // disable default icon
      html: tableHTML,
      width: 760,
      showCancelButton: true,
      showConfirmButton: true,
      showDenyButton: true,

      confirmButtonText: "I Understand",
      denyButtonText: "Update Form Data Only",
      cancelButtonText: "Cancel",

      confirmButtonColor: "#dc3545",
      denyButtonColor: "#17a2b8",
      cancelButtonColor: "#6c757d",

      allowOutsideClick: false,

      customClass: {

        confirmButton: 'swal-btn-sm',
        denyButton: 'swal-btn-sm',
        cancelButton: 'swal-btn-sm',
        actions: 'swal-actions-center'
      },

      didOpen: () => {
        // center buttons like screenshot
        const style = document.createElement('style');
        style.textContent = `
          .swal-btn-sm {
            font-size: 12px !important;
            padding: 6px 14px !important;
            border-radius: 4px !important;
            min-height: auto !important;
          }
    
          .swal-actions-center {
            justify-content: center !important;
            gap: 10px !important;
          }
        `;
        document.head.appendChild(style);
        const actions = document.querySelector('.swal2-actions');
        if (actions) {
          actions.style.justifyContent = "center";
          actions.style.gap = "12px";
        }

        window.editPackage = (packageId) => {
          Swal.close();
          window.open(`/package/edit?packageId=${packageId}`, "_blank");
        };
      },
    }).then((result) => {
      if (result.isConfirmed) {
        // SAME AS BEFORE → BLOCK STATUS CHANGE
        rollbackVariantStatus(variantsBeingInactivated.map(v => v._id));
      } else if (result.isDenied) {
        // SAME AS BEFORE → FORM DATA ONLY
        proceedWithServiceUpdate({
          allowStatusUpdate: false,
          allowFormDataUpdate: true,
        });
      } else {
        rollbackVariantStatus(variantsBeingInactivated.map(v => v._id));
      }
    });
  };



  useEffect(() => {
    if (itemm && combineData?.parentCategories) {
      // Compute derived values inside useEffect to ensure they use latest itemm
      const childCtegoryEditedValues = {
        value: itemm?.ChildCatIDs?._id,
        label: itemm?.ChildCatIDs?.CCName,
      };
      const newValues = [childCtegoryEditedValues];

      const parentCategoryValues = {
        value: itemm?.PCatId?._id,
        label: itemm?.PCatId?.PCName,
      };

      const serviceTypes = itemm?.ServiceVarients?.map((item) => ({
        selectedIds: item?.ServiceType?._id,
        selectedlabel: item?.ServiceType?.Name,
        _id: item?._id,
      }));

      console.log('Setting form values - parentCategoryValues:', parentCategoryValues);
      console.log('Setting form values - serviceTypes:', serviceTypes);

      setSelectedChildCategories(newValues);
      setSelectedParentCategory(parentCategoryValues);
      setSelectedServiceType(serviceTypes);
    }
  }, [itemm, combineData]);

  const handleParentCategoryChange = (selectedOption) => {
    setSelectedParentCategory({
      value: selectedOption?.value,
      label: selectedOption?.label,
    });
  };

  const filteredChildCategories =
    combineData &&
    combineData?.childCategories?.filter(
      (category) => category?.PCName[0] === selectedParentCategory?.value
    );

  const filteredServiceGroups = combineData?.serviceGroups?.filter(
    (group) => group.PCName[0] === selectedParentCategory?.value
  );

  const filteredServiceTypes = combineData?.serviceTypes?.filter((type) =>
    type.PCName.some((pcName) => pcName === selectedParentCategory?.value)
  );

  useEffect(() => {
    getAllDocumentData();
  }, []);

  useEffect(() => {
    const childCategorySelectOptions = filteredChildCategories?.map(
      (category) => ({
        value: category._id,
        label: category.CCName,
      })
    );
    setChildCategoryOptions(childCategorySelectOptions || []);
  }, [selectedParentCategory, combineData?.childCategories]);

  useEffect(() => {
    const serviceGroupSelectOptions = filteredServiceGroups?.map((group) => ({
      value: group._id,
      label: group.GroupName,
    }));
    setServiceGroupOptions(serviceGroupSelectOptions || []);
  }, [selectedParentCategory, combineData?.serviceGroups]);

  useEffect(() => {
    const serviceTypeSelectOptions = filteredServiceTypes?.map((type) => ({
      value: type._id,
      label: type.Name,
    }));
    setServiceTypeOptions(serviceTypeSelectOptions || []);
  }, [selectedParentCategory, combineData?.serviceTypes]);

  const handleVariantChangee = (serviceType, index, field, value, id) => {
    setServiceVariants((prevVariants) => {
      return prevVariants.map((variant, i) => {
        if (i === index) {
          return {
            ...variant,
            _id: id,
            ServiceType: serviceType,
            VariantDescription: variant?.VariantDescription?.map(
              (description, j) => {
                if (j === 0) {
                  return {
                    ...description,
                    [field]: value,
                  };
                }
                return description;
              }
            ),
          };
        }
        return variant;
      });
    });
  };

  const fillTargetArray = () => {
    if (!itemm || !itemm.ServiceVarients) return; // Check if itemm and ServiceVarients are defined

    const filledArray = itemm?.ServiceVarients?.map((item, index) => {
      const newVariant = {
        VariantDescription: [
          {
            regularPrice: "",
            salePrice: "",
            serviceDiscount: "",
            ServiceGroup: "",
            ServiceTiming: "",
            Imagee: "",
            ShortDiscription: "",
            Status: "",
            Discription: "",
            ShowInChildCategory: "",
            IsServiceDiscription: false,
          },
        ],
      };

      if (SelectServiceType?.length === 1) {
        setServiceVariants([newVariant]);
      } else {
        setServiceVariants((prevVariants) => [...prevVariants, newVariant]);
      }

      handleVariantChangee(
        item.ServiceType?._id,
        index,
        "ServiceTiming",
        item.VarientDiscription[0].ServiceTime,
        item?._id
      );
      // handleVariantChangee(item.ServiceType?._id, index, "_id", item._id);
      let id = item.VarientDiscription[0].ServiceGroups.map(
        (group) => group?._id
      );
      handleVariantChangee(
        item.ServiceType?._id,
        index,
        "ServiceGroup",
        id,
        item?._id
      );
      let ShowInChildCatego =
        item.VarientDiscription[0].ShowInChildCategory.map(
          (group) => group?._id
        );
      handleVariantChangee(
        item.ServiceType?._id,
        index,
        "ShowInChildCategory",
        ShowInChildCatego,
        item?._id
      );

      handleVariantChangee(
        item.ServiceType?._id,
        index,
        "regularPrice",
        item.VarientDiscription[0].regularPrice,
        item?._id
      );
      handleVariantChangee(
        item.ServiceType?._id,
        index,
        "ProductCost",
        item.VarientDiscription[0].ProductCost,
        item?._id
      );
      handleVariantChangee(
        item.ServiceType?._id,
        index,
        "salePrice",
        item.VarientDiscription[0].salePrice,
        item?._id
      );
      handleVariantChangee(
        item.ServiceType?._id,
        index,
        "serviceDiscount",
        item.VarientDiscription[0].serviceDiscount,
        item?._id
      );
      handleVariantChangee(
        item.ServiceType?._id,
        index,
        "Discription",
        item.VarientDiscription[0]?.ServiceDiscription,
        item?._id
      );

      handleVariantChangee(
        item.ServiceType?._id,
        index,
        "ShortDiscription",
        item.VarientDiscription[0]?.ShortDiscription,
        item?._id
      );

      handleVariantChangee(
        item.ServiceType?._id,
        index,
        "Status",
        item.VarientDiscription[0]?.ServiceStatus == true ? "1" : "0",
        item?._id
      );
      handleVariantChangee(
        item.ServiceType?._id,
        index,
        "Imagee",
        item.VarientDiscription[0]?.ServiceImage,
        item?._id
      );
      handleVariantChangee(
        item.ServiceType?._id,
        index,
        "IsServiceDiscription",
        item.VarientDiscription[0]?.IsServiceDiscription,
        item?._id
      );
      // Return the item itself if you want to include it in the target array
      return item;
    });

    // setServiceVariants(filledArray); // Update the target array state
  };

  // useEffect to call fillTargetArray when itemm changes
  useEffect(() => {
    fillTargetArray();
  }, [itemm, ServiceTypeOptions]);

  // Show loading indicator while fetching data
  if (isLoading) {
    return (
      <div className="app-main">
        <div className="wrapper">
          <div className="page">
            <div className="page-inner">
              <div className="container-fluid">
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                  <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                    <p className="mt-2">Loading service data...</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="app-main">
        <div className="wrapper">
          <div className="page">
            <div className="page-inner">
              <div className="container-fluid">
                <header className="page-title-bar">
                  <div className="d-flex flex-column flex-md-row">
                    <p className="lead mb-0">
                      <span className="font-weight-bold">Services</span>
                    </p>
                    <Link
                      to="/service/"
                      className="btn btn-primary btn-sm ml-auto"
                      data-toggle="modal"
                      data-target="#childModal"
                    >
                      <i className="fa fa-plus mr-2"></i>All Services
                    </Link>
                  </div>
                </header>
                <div className="page-section">
                  <div className="card">
                    <div className="card-body table-responsive">
                      <form>
                        <div className="row">
                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Service Name</label>
                              <input
                                value={Name}
                                onChange={(e) => setName(e.target.value)}
                                type="text"
                                className="form-control"
                                placeholder="Service Name"
                              />
                            </div>
                          </div>

                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Service Status</label>
                              <select
                                value={ServiceStatus}
                                onChange={(e) => handleServiceStatusChange(e.target.value)}
                                className="form-control"
                                disabled
                              >
                                <option value="1">Active</option>
                                <option value="0">Inactive</option>
                              </select>
                            </div>
                          </div>


                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Parent Category</label>
                              <Select
                                isClearable
                                label={selectedParentCategory}
                                value={selectedParentCategory}
                                onChange={(selectedOption) => {
                                  handleParentCategoryChange(selectedOption);
                                }}
                                options={
                                  combineData?.parentCategories?.map(
                                    (category) => ({
                                      value: category._id,
                                      label: category.PCName,
                                    })
                                  ) || []
                                }
                              />
                            </div>
                          </div>

                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Child Category</label>

                              <Select
                                isClearable
                                value={selectedChildCategories}
                                options={childCategoryOptions}
                                onChange={(selectedOption) => {
                                  setSelectedChildCategories({
                                    value: selectedOption.value,
                                    label: selectedOption.label,
                                  });
                                }}
                              />
                            </div>
                          </div>

                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Service Type</label>

                              <Select
                                isMulti
                                value={ServiceTypeOptions?.filter((option) =>
                                  SelectServiceType?.some(
                                    (selected) =>
                                      option.value.toString() ===
                                      selected.selectedIds
                                  )
                                )}
                                options={ServiceTypeOptions}
                                onChange={(selectedOptions) => {
                                  const selectedServiceTypes =
                                    selectedOptions.map((option) => ({
                                      selectedIds: option.value.toString(),
                                      selectedlabel: option.label.toString(),
                                    }));

                                  setSelectedServiceType(selectedServiceTypes);
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <hr />

                        {Array.isArray(SelectServiceType) &&
                          SelectServiceType.map((item, index) => {
                            let selectedValues =
                              serviceVariants[index]?.VariantDescription[0]
                                .ServiceGroup || [];
                            let selectedShow =
                              serviceVariants[index]?.VariantDescription[0]
                                .ShowInChildCategory || [];

                            let selectedshowOptions = selectedShow.map(
                              (value) => {
                                let matchingOption = childCategoryOptions.find(
                                  (item) => item.value === value
                                );
                                return matchingOption
                                  ? { value, label: matchingOption.label }
                                  : null;
                              }
                            );

                            let selectedOptions = selectedValues.map(
                              (value) => {
                                let matchingOption = ServiceGroupOptions.find(
                                  (item) => item.value === value
                                );
                                return matchingOption
                                  ? { value, label: matchingOption.label }
                                  : null;
                              }
                            );

                            const regularPrice =
                              serviceVariants[index]?.VariantDescription[0]
                                ?.regularPrice || 0;
                            const salePrice =
                              serviceVariants[index]?.VariantDescription[0]
                                ?.salePrice || 0;
                            let newDiscountPercentage = Math.floor(
                              ((regularPrice - salePrice) / regularPrice) *
                              100 || 0
                            );

                            if (
                              serviceVariants[index]?.VariantDescription[0]
                                ?.serviceDiscount
                            ) {
                              newDiscountPercentage =
                                serviceVariants[index]?.VariantDescription[0]
                                  ?.serviceDiscount;
                            }
                            const file =
                              serviceVariants[index]?.VariantDescription[0]
                                .ServiceImage;
                            let imgSrc = "";
                            if (file) {
                              imgSrc = URL.createObjectURL(file);
                            }
                            return (
                              <div key={index} className="card">
                                <div className="card-header">
                                  <h4 className="card-title mb-0 ">
                                    {item?.selectedlabel}
                                  </h4>
                                </div>
                                <div className="card-body">
                                  <div className="row">
                                    <div className="col-lg-3">
                                      <div className="form-group">
                                        <label>Service Type</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Service Type"
                                          value={item?.selectedlabel}
                                          readOnly
                                        />
                                      </div>
                                    </div>

                                    <div className="col-lg-3">
                                      <div className="form-group">
                                        <label>Service Group</label>
                                        <Select
                                          isMulti
                                          value={selectedOptions}
                                          options={ServiceGroupOptions}
                                          onChange={(selectedOptions) => {
                                            const selectedIds =
                                              selectedOptions.map(
                                                (option) => option.value
                                              );

                                            handleVariantChangee(
                                              item?.selectedIds,
                                              index,
                                              "ServiceGroup",
                                              selectedIds,
                                              item?.selectedIds
                                            );
                                          }}
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-3">
                                      <div className="form-group">
                                        <label>Service Timing</label>
                                        <input
                                          type="text"
                                          value={
                                            serviceVariants[index]
                                              ?.VariantDescription[0]
                                              .ServiceTiming || ""
                                          }
                                          onChange={(e) =>
                                            handleVariantChangee(
                                              item?.selectedIds,
                                              index,
                                              "ServiceTiming",
                                              e.target.value,
                                              item?.selectedIds
                                            )
                                          }
                                          id="inputName"
                                          className="form-control"
                                          placeholder="Timing"
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-3">
                                      <div className="form-group">
                                        <label>Regular Price</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Regular Price"
                                          value={
                                            serviceVariants[index]
                                              ?.VariantDescription[0]
                                              .regularPrice || ""
                                          }
                                          onChange={(e) => {
                                            handleVariantChangee(
                                              item?.selectedIds,
                                              index,
                                              "regularPrice",
                                              e.target.value,
                                              item?.selectedIds
                                            );
                                          }}
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-3">
                                      <div className="form-group">
                                        <label>Product Cost</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Product Cost"
                                          value={
                                            serviceVariants[index]
                                              ?.VariantDescription[0]
                                              .ProductCost || ""
                                          }
                                          onChange={(e) =>
                                            handleVariantChangee(
                                              item?.selectedIds,
                                              index,
                                              "ProductCost",
                                              e.target.value,
                                              item?.selectedIds
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-3">
                                      <div className="form-group">
                                        <label>Sale Price</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Sale Price"
                                          value={
                                            serviceVariants[index]
                                              ?.VariantDescription[0]
                                              .salePrice || ""
                                          }
                                          onChange={(e) => {
                                            const newSalePrice = e.target.value;
                                            const newDiscountPercentage =
                                              Math.floor(
                                                ((regularPrice - newSalePrice) /
                                                  regularPrice) *
                                                100 || 0
                                              );
                                            handleVariantChangee(
                                              item?.selectedIds,
                                              index,
                                              "salePrice",
                                              newSalePrice,
                                              item?.selectedIds
                                            );
                                            handleVariantChangee(
                                              item?.selectedIds,
                                              index,
                                              "serviceDiscount",
                                              newDiscountPercentage,
                                              item?.selectedIds
                                            );
                                          }}
                                        />
                                      </div>
                                    </div>

                                    <div className="col-lg-3">
                                      <div className="form-group">
                                        <label>Discount (%)</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Discount (%)"
                                          readOnly
                                          value={newDiscountPercentage}
                                        />
                                      </div>
                                    </div>

                                    <div className="col-lg-3">
                                      <div className="form-group">
                                        <label>Image</label>
                                        <input
                                          type="file"
                                          className="form-control"
                                          accept="image/*"
                                          onChange={(event) => {
                                            const file = event.target.files[0];
                                            if (file) {
                                              handleVariantChangee(
                                                item?.selectedIds,
                                                index,
                                                "Imagee",
                                                file,
                                                item?.selectedIds
                                              );

                                              const reader = new FileReader();
                                              reader.onloadend = () => {
                                                setImagePreview(reader.result);
                                              };
                                              reader.readAsDataURL(file);
                                            }
                                          }}
                                        />
                                      </div>
                                    </div>

                                    <div className="col-lg-3">
                                      <div className="form-group">
                                        <label>Status</label>
                                        <select
                                          className="form-control"
                                          value={serviceVariants[index]?.VariantDescription[0]?.Status || "1"}
                                          disabled

                                          onChange={(e) => {
                                            const nextStatus = e.target.value;
                                            const variantId = serviceVariants[index]?._id;

                                            // Only intercept when trying to inactivate
                                            if (nextStatus === "0" && variantId) {
                                              const packages = findPackagesUsingServiceVariant(variantId);

                                              // Detect active packages (same logic as before)
                                              const activePackages = packages.filter(
                                                (pkg) =>
                                                  pkg.Status === true ||
                                                  pkg.Status === 1 ||
                                                  pkg.status === true ||
                                                  pkg.status === 1
                                              );

                                              if (activePackages.length > 0) {
                                                // 🔥 BUILD SAME TABLE UI
                                                const packagesTable = packages
                                                  .map((pkg) => {
                                                    const isActive =
                                                      pkg.Status === true ||
                                                      pkg.Status === 1 ||
                                                      pkg.status === true ||
                                                      pkg.status === 1;

                                                    return `
                                                    <tr style="height: 36px;">
                                                      <td style="padding: 6px 10px;">
                                                        <strong style="font-size: 12px;">
                                                          ${pkg.packageTitle || pkg.name || pkg._id}
                                                        </strong>
                                                      </td>
                                                      <td style="padding: 6px 10px; text-align:center;">
                                                        <span class="badge ${isActive ? "badge-success" : "badge-secondary"}"
                                                              style="font-size:10px;">
                                                          ${isActive ? "Active" : "Inactive"}
                                                        </span>
                                                      </td>
                                                      <td style="padding: 6px 10px;">
                                                        <button
                                                          class="btn btn-xs btn-primary"
                                                          style="font-size:10px; padding:2px 6px;"
                                                          onclick="editPackage('${pkg._id}')">
                                                          <i class="fas fa-edit"></i> Edit
                                                        </button>
                                                      </td>
                                                    </tr>
                                                    `;
                                                  })
                                                  .join("");

                                                const tableHTML = `
                                                  <div class="alert alert-warning mb-2"
                                                      style="padding:8px 12px; font-size:12px;">
                                                    <i class="fas fa-exclamation-triangle me-1"></i>
                                                    <strong>This variant is used in active packages.</strong>
                                                    You cannot inactivate it.
                                                  </div>

                                                  <div class="table-responsive"
                                                      style="max-height:160px; overflow-y:auto;
                                                              border:1px solid #dee2e6; border-radius:4px;">
                                                    <table class="table table-striped mb-0"
                                                          style="font-size:11px;">
                                                      <thead class="table-dark"
                                                            style="position:sticky; top:0; z-index:10;">
                                                        <tr>
                                                          <th style="padding:8px;">
                                                            <i class="fas fa-box me-1"></i> Package Details
                                                          </th>
                                                          <th style="padding:8px; text-align:center;">
                                                            <i class="fas fa-info-circle me-1"></i> Status
                                                          </th>
                                                          <th style="padding:8px;">
                                                            <i class="fas fa-edit me-1"></i> Action
                                                          </th>
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                        ${packagesTable}
                                                      </tbody>
                                                    </table>
                                                  </div>
                                                        `;

                                                Swal.fire({
                                                  icon: "warning",
                                                  title: "Variant Used in Packages",
                                                  html: tableHTML,
                                                  width: 700,
                                                  confirmButtonText: "OK",
                                                  allowOutsideClick: false,
                                                  customClass: {
                                                    popup: "swal-compact",
                                                    confirmButton: "btn btn-primary btn-sm",
                                                  },
                                                  didOpen: () => {
                                                    window.editPackage = (packageId) => {
                                                      Swal.close();
                                                      window.open(`/package/edit?packageId=${packageId}`, "_blank");
                                                    };
                                                  },
                                                });

                                                return; // ⛔ HARD BLOCK — state NOT changed
                                              }
                                            }

                                            // ✅ Safe → apply status
                                            handleVariantChangee(
                                              item?.selectedIds,
                                              index,
                                              "Status",
                                              nextStatus,
                                              variantId
                                            );
                                          }}
                                        >
                                          <option value="1">Active</option>
                                          <option value="0">Inactive</option>
                                        </select>


                                      </div>
                                    </div>

                                    <div className="col-lg-4">
                                      {typeof serviceVariants[index]
                                        ?.VariantDescription[0]?.Imagee ===
                                        "string" &&
                                        serviceVariants[
                                          index
                                        ]?.VariantDescription[0]?.Imagee.startsWith(
                                          "/uploads"
                                        ) ? (
                                        <img
                                          width="80"
                                          height="50"
                                          src={
                                            Image_URL +
                                            serviceVariants[index]
                                              ?.VariantDescription[0].Imagee
                                          }
                                          alt="Preview"
                                          style={{ maxWidth: "100%" }}
                                        />
                                      ) : serviceVariants[index]
                                        ?.VariantDescription[0]
                                        ?.Imagee instanceof File ? (
                                        <img
                                          width="80"
                                          height="50"
                                          src={URL.createObjectURL(
                                            serviceVariants[index]
                                              ?.VariantDescription[0].Imagee
                                          )}
                                          alt="Preview"
                                          style={{ maxWidth: "100%" }}
                                        />
                                      ) : (
                                        <img
                                          width="80"
                                          height="50"
                                          src={imgSrc}
                                          alt="Preview"
                                          style={{ maxWidth: "100%" }}
                                        />
                                      )}
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-lg-12">
                                      <div className="form-group">
                                        <label>Show in Child Category</label>
                                        <Select
                                          isMulti
                                          value={selectedshowOptions}
                                          options={childCategoryOptions}
                                          onChange={(selectedOptions) => {
                                            const selectedIds =
                                              selectedOptions.map(
                                                (option) => option.value
                                              );
                                            handleVariantChangee(
                                              item?.selectedIds,
                                              index,
                                              "ShowInChildCategory",
                                              selectedIds,
                                              item?.selectedIds
                                            );
                                          }}
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-12">
                                      <div className="form-group">
                                        <label>Short Discription</label>
                                        <ReactQuill
                                          className="h-100 editor"
                                          modules={{
                                            toolbar: [
                                              [{ header: [1, 2, false] }],
                                              [
                                                "bold",
                                                "italic",
                                                "underline",
                                                "strike",
                                                "blockquote",
                                              ],
                                              [
                                                { list: "ordered" },
                                                { list: "bullet" },
                                                { indent: "-1" },
                                                { indent: "+1" },
                                              ],
                                              ["link", "image"],
                                              ["clean"],
                                            ],
                                          }}
                                          theme="snow"
                                          formats={[
                                            "header",
                                            "bold",
                                            "italic",
                                            "underline",
                                            "strike",
                                            "blockquote",
                                            "list",
                                            "bullet",
                                            "indent",
                                            "link",
                                            "image",
                                          ]}
                                          value={
                                            serviceVariants[index]
                                              ?.VariantDescription[0]
                                              .ShortDiscription
                                          }
                                          onChange={(e) => {
                                            setEditorData(e);
                                            handleVariantChangee(
                                              item?.selectedIds,
                                              index,
                                              "ShortDiscription",
                                              e,
                                              item?.selectedIds
                                            );
                                          }}
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-12">
                                      <div className="form-group">
                                        <label>Discription</label>

                                        <ReactQuill
                                          className="h-100 editor"
                                          modules={{
                                            toolbar: [
                                              [{ header: [1, 2, false] }],
                                              [
                                                "bold",
                                                "italic",
                                                "underline",
                                                "strike",
                                                "blockquote",
                                              ],
                                              [
                                                { list: "ordered" },
                                                { list: "bullet" },
                                                { indent: "-1" },
                                                { indent: "+1" },
                                              ],
                                              ["link", "image"],
                                              ["clean"],
                                            ],
                                          }}
                                          theme="snow"
                                          formats={[
                                            "header",
                                            "bold",
                                            "italic",
                                            "underline",
                                            "strike",
                                            "blockquote",
                                            "list",
                                            "bullet",
                                            "indent",
                                            "link",
                                            "image",
                                          ]}
                                          value={
                                            serviceVariants[index]
                                              ?.VariantDescription[0]
                                              .Discription
                                          }
                                          onChange={(e) => {
                                            setEditorData(e);
                                            handleVariantChangee(
                                              item?.selectedIds,
                                              index,
                                              "Discription",
                                              e,
                                              item?.selectedIds
                                            );
                                          }}
                                        />
                                      </div>
                                      <div className="custom-control custom-control-inline custom-checkbox">
                                        <input
                                          type="checkbox"
                                          className="custom-control-input"
                                          id={`ckb${index}`}
                                          name="spCommentShow"
                                          checked={
                                            serviceVariants[index]
                                              ?.VariantDescription[0]
                                              ?.IsServiceDiscription == true
                                              ? true
                                              : false
                                          }
                                          value="1"
                                          onChange={(e) => {
                                            handleVariantChangee(
                                              item?.selectedIds,
                                              index,
                                              "IsServiceDiscription",
                                              !serviceVariants[index]
                                                ?.VariantDescription[0]
                                                ?.IsServiceDiscription,
                                              item?.selectedIds
                                            );
                                            // setisDiscription(!isDiscription);
                                          }}
                                        />{" "}
                                        <label
                                          className="custom-control-label"
                                          htmlFor={`ckb${index}`}
                                        >
                                          Is Description
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}

                        <hr />

                        <div className="row">
                          <div className="col-lg-12">
                            <button
                              type="button"
                              className="btn btn-primary "
                              onClick={handleSubmit}
                            >
                              Update Service
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EditService;